<template>
  <v-row
      v-if="$store.getters.isSettingsReady && order"
      justify="center"
  >

    <template v-if="loading">
      <v-col cols="12" sm="6" md="8">
        <loading></loading>
      </v-col>
    </template>

    <template>

      <v-col cols="12" md="8">

        <v-row dense>
          <v-col cols="12" md="6">
            <show-order-state
                :order="order"
            />

          </v-col>

          <v-col cols="12" md="6">

            <show-order-payment
                :order="order"
                @orderModified="onOrderModified"
            ></show-order-payment>

          </v-col>

          <v-col cols="12">

          </v-col>

          <v-col cols="12">
            <show-order-location
                :order="order"
            />
          </v-col>

          <v-col cols="12">
            <show-order-contact
                :order="order"
            />
          </v-col>


        </v-row>

      </v-col>


      <v-col cols="12" md="4">
        <show-order-items
            :order="order"
        />
      </v-col>


    </template>
  </v-row>
</template>

<script>
import ShowOrderContact
  from "@/modules/delivery/components-core/shared/ShowOrder/ShowOrderContact/ShowOrderContact.vue";
import ShowOrderLocation
  from "@/modules/delivery/components-core/shared/ShowOrder/ShowOrderLocation/ShowOrderLocation.vue";
import ShowOrderItems from "@/modules/delivery/components-core/shared/ShowOrder/ShowOrderItems/ShowOrderItems.vue";
import {Loading} from "@dracul/common-frontend"
import ShowOrderState from "@/modules/delivery/components-core/shared/ShowOrder/ShowOrderState/ShowOrderState.vue";
import ShowOrderPayment
  from "@/modules/delivery/components-core/shared/ShowOrder/ShowOrderPayment/ShowOrderPayment.vue";
import OrderProvider from "@/modules/delivery/providers/OrderProvider";


export default {
  name: "ShowOrder",
  components: {
    Loading,
    ShowOrderPayment,
    ShowOrderState,
    ShowOrderItems,
    ShowOrderLocation,
    ShowOrderContact
  },
  props: {
    identifier: {type: String, required: true},
  },
  data() {
    return {
      order: null,
      loading: false,
      loadingSate: false,
      timeout: null
    }
  },
  mounted() {
    this.fetchOrder()
    this.refreshOrder()
  },
  destroyed() {
    clearTimeout(this.timeout)
  },
  methods: {
    onOrderModified(order) {
      this.order = order
    },
    async fetchOrder() {

      try{
        this.loading = true
        let r = await OrderProvider.orderFindByIdentifier(this.identifier)
        if (r.data.orderFindByIdentifier) {
          this.order = r.data.orderFindByIdentifier
          console.log("Order fetched: ", this.order)
          this.loading = false
        } else {
          this.$store.commit("clearOrder")
          this.redirectToHome()
        }

      }catch (e) {
        console.error(e)
      }finally {
        this.loading = false
      }


    },
    refreshOrder() {
      this.timeout = setTimeout(() => {
        this.fetchOrder()
        this.refreshOrder()
      }, 30000)
    },
    redirectToHome() {
      this.$router.push({
        name: 'home'
      })
    }
  }

}
</script>

<style scoped>

</style>
